import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  TextArea,
  Button,
  Icon,
  Dropdown,
  Input
} from 'semantic-ui-react'

const ClinicalFindings = React.forwardRef((props: any, ref: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div>
        <div
          style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gridTemplateRows: "repeat(2, 1fr)", backgroundColor: "#CCE6F8", padding:"5px" }}>
          <div
            style={{ margin: "5px", gridRow: 1, gridColumn: "1/3", display: "flex", flexDirection: "column"}}>
            
            <label
              style={{paddingBottom:"5px"}}>
              Location
            </label>
            <Input
              readOnly={true}
              ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#e8e8e8", ref.inputRef.current.style.color= "rgba(0, 0, 0, 0.6)")}
              value={props.clinicalFinding?.locations_name || ""}>
            </Input>
          </div>
          <div
            style={{ margin: "5px", gridRow: "1", gridColumn: "3/5", display: "flex", flexDirection: "column"}}>
            <label
              style={{paddingBottom:"5px", display: "flex"}}>
              Principal Diagnosis
              <div>
                {props.children}
              </div>
            </label>
            <Input
              readOnly={true}
              ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#e8e8e8", ref.inputRef.current.style.color= "rgba(0, 0, 0, 0.6)")}
              style={{color: "rgba(0,0,0,.6)"}}
              value={props.clinicalFinding?.medical_description || ""}>
            </Input>
          </div>
          <div
            style={{ margin: "5px", gridRow: 2, gridColumn: "1/3", display: "flex", flexDirection: "column"}}>
            
            <label
              style={{paddingBottom:"5px"}}>
              Clinical finding
            </label>
            <Input
              readOnly={true}
              ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#e8e8e8", ref.inputRef.current.style.color= "rgba(0, 0, 0, 0.6)")}
              style={{color: "rgba(0,0,0,.6)"}}
              value={props.clinicalFinding?.clinicaltags || ""}>
            </Input>
          </div>
          <div
            style={{ margin: "5px", gridRow: "3/5", gridColumn: "1/3", display: "flex", flexDirection: "column"}}>
            <div
              style={{display:"flex",  justifyContent:"space-between", alignItems:"center"}}>
              
              <label>
                Other Clinical finding
              </label>
              <Button
                className="mini"
                color="yellow"
                onClick={()=>props.setProp("showClinicalFindingTerms", true)}
                style={{padding: "5px 0px 8px 9.5px", marginBottom:"5px"}}>
                <Icon
                  className="large"
                  name={"cog"}>
                </Icon>
              </Button>
            </div>
            <Form>
              <TextArea
                onChange={(e) => { console.log(e.key); props.setProp(`clinicalFindingList.${props.clinicalFindingIndex}.other_clinical_finding`, e.target.value) }}
                onInput={(e)=> {console.log(e.key)}}
                onKeyDown={(e)=> props.onEvent({ message: "SetKeyboardShortcutToClinicalFinding", params: {event:e, clinicalFindingIndex: props.clinicalFindingIndex} })}
                readOnly={props.readOnly}
                rows="8"
                style={{ ...(props.readOnly && {backgroundColor:"#e8e8e8"})}}
                value={props.clinicalFinding?.other_clinical_finding}>
              </TextArea>
            </Form>
          </div>
          <div
            style={{ margin: "5px", gridRow: 2, gridColumn: "3/5", display: "flex", flexDirection: "column"}}>
            <label
              style={{paddingBottom:"5px"}}>
              Principal ICD10
            </label>
            <Input
              readOnly={true}
              ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#e8e8e8", ref.inputRef.current.style.color= "rgba(0, 0, 0, 0.6)")}
              style={{color: "rgba(0,0,0,.6)"}}
              value={props.clinicalFinding?.icd10_label || ""}>
            </Input>
          </div>
          <div
            style={{ margin: "5px",  gridRow: 3, gridColumn: "3/5", display: "flex", flexDirection: "column", marginTop:"18.5px"}}>
            <label
              style={{paddingBottom:"5px"}}>
              Other investigations and interpretation
            </label>
            <Form>
              <TextArea
                onChange={(e) => { props.setProp(`clinicalFindingList.${props.clinicalFindingIndex}.other_investigation`, e.target.value) }}
                readOnly={props.readOnly}
                rows="3"
                style={{ ...(props.readOnly && {backgroundColor:"#e8e8e8"})}}
                value={props.clinicalFinding?.other_investigation}>
              </TextArea>
            </Form>
          </div>
          <div
            style={{ margin: "5px", gridRow: 4, gridColumn: "3/5", display: "flex", flexDirection: "column"}}>
            <label
              style={{paddingBottom:"5px"}}>
              Prognosis
            </label>
            <Dropdown
              disabled={props.readOnly}
              onChange={(e,{value}) => { props.setProp(`clinicalFindingList.${props.clinicalFindingIndex}.prognosis`, value) }}
              options={props.prognosisOptions}
              search="true"
              selection={true}
              value={props.clinicalFinding?.prognosis}>
            </Dropdown>
          </div>
        </div>
      </div>
    )
})

ClinicalFindings.displayName = "ClinicalFindings";
export default ClinicalFindings

export const screenPropsDefault = {"diagnosis":"tooth cavity"}

/* Date Time : Thu Sep 19 2024 20:03:59 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"grid\", gridTemplateColumns: \"repeat(4, 1fr)\", gridTemplateRows: \"repeat(2, 1fr)\", backgroundColor: \"#CCE6F8\", padding:\"5px\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", gridRow: 1, gridColumn: \"1/3\", display: \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "Location"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom:\"5px\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 23,
      "props": {
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", gridRow: \"1\", gridColumn: \"3/5\", display: \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 23,
      "props": {
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", gridRow: \"3/5\", gridColumn: \"1/3\", display: \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 23,
      "props": {
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", gridRow: 2, gridColumn: \"3/5\", display: \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "Principal Diagnosis"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom:\"5px\", display: \"flex\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "Principal ICD10"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom:\"5px\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Form",
      "parent": 29,
      "props": {
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "TextArea",
      "parent": 83,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e) => { console.log(e.key); props.setProp(`clinicalFindingList.${props.clinicalFindingIndex}.other_clinical_finding`, e.target.value) }"
        },
        "onInput": {
          "type": "code",
          "value": "(e)=> {console.log(e.key)}"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e)=> props.onEvent({ message: \"SetKeyboardShortcutToClinicalFinding\", params: {event:e, clinicalFindingIndex: props.clinicalFindingIndex} })"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "rows": {
          "type": "value",
          "value": "8"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.readOnly && {backgroundColor:\"#e8e8e8\"})}"
        },
        "value": {
          "type": "code",
          "value": "props.clinicalFinding?.other_clinical_finding"
        }
      },
      "seq": 88,
      "void": true
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 23,
      "props": {
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\",  gridRow: 3, gridColumn: \"3/5\", display: \"flex\", flexDirection: \"column\", marginTop:\"18.5px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "label",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": "Other investigations and interpretation"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom:\"5px\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 23,
      "props": {
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", gridRow: 4, gridColumn: \"3/5\", display: \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "label",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": "Prognosis"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom:\"5px\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",  justifyContent:\"space-between\", alignItems:\"center\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "Other Clinical finding"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Button",
      "parent": 97,
      "props": {
        "className": {
          "type": "value",
          "value": "mini"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "icon": {
          "type": "value",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "()=>props.setProp(\"showClinicalFindingTerms\", true)"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px 0px 8px 9.5px\", marginBottom:\"5px\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "Icon",
      "parent": 99,
      "props": {
        "className": {
          "type": "value",
          "value": "large"
        },
        "name": {
          "type": "code",
          "value": "\"cog\""
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", gridRow: 2, gridColumn: \"1/3\", display: \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "Clinical finding"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom:\"5px\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Form",
      "parent": 91,
      "props": {
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "TextArea",
      "parent": 107,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e) => { props.setProp(`clinicalFindingList.${props.clinicalFindingIndex}.other_investigation`, e.target.value) }"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "rows": {
          "type": "value",
          "value": "3"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.readOnly && {backgroundColor:\"#e8e8e8\"})}"
        },
        "value": {
          "type": "code",
          "value": "props.clinicalFinding?.other_investigation"
        }
      },
      "seq": 108,
      "void": true
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.children"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Dropdown",
      "parent": 94,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "onChange": {
          "type": "code",
          "value": "(e,{value}) => { props.setProp(`clinicalFindingList.${props.clinicalFindingIndex}.prognosis`, value) }"
        },
        "options": {
          "type": "code",
          "value": "props.prognosisOptions"
        },
        "search": {
          "type": "value",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.clinicalFinding?.prognosis"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "Input",
      "parent": 24,
      "props": {
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#e8e8e8\", ref.inputRef.current.style.color= \"rgba(0, 0, 0, 0.6)\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.clinicalFinding?.locations_name || \"\""
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "Input",
      "parent": 103,
      "props": {
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#e8e8e8\", ref.inputRef.current.style.color= \"rgba(0, 0, 0, 0.6)\")"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0,0,0,.6)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.clinicalFinding?.clinicaltags || \"\""
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "Input",
      "parent": 28,
      "props": {
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#e8e8e8\", ref.inputRef.current.style.color= \"rgba(0, 0, 0, 0.6)\")"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0,0,0,.6)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.clinicalFinding?.medical_description || \"\""
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Input",
      "parent": 30,
      "props": {
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#e8e8e8\", ref.inputRef.current.style.color= \"rgba(0, 0, 0, 0.6)\")"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0,0,0,.6)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.clinicalFinding?.icd10_label || \"\""
        }
      },
      "seq": 121,
      "void": false
    }
  ],
  "forwardRef": true,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "ClinicalFindings",
  "project": "cudent",
  "screenPropsDefault": {
    "diagnosis": "tooth cavity"
  },
  "width": 80
}

*********************************************************************************** */
